import React from 'react'
import { Box, Container, Paper, SimpleGrid, Text } from '@mantine/core'
import SectionHeader from './shared/SectionHeader'
import { BRAND_COLOR, QUERY_TYPES_CONTENT } from '../utils/constants'

export default function QueryTypes() {
  return (
    <Box id="query-types" py={{ base: 60, md: 100 }} style={{ backgroundColor: '#F5F7FA' }}>
      <Container size="xl">
        <SectionHeader badge={QUERY_TYPES_CONTENT.badge} title={QUERY_TYPES_CONTENT.title} centered />

        <SimpleGrid cols={{ base: 2, md: 4 }} spacing="lg" mt={40}>
          {QUERY_TYPES_CONTENT.types.map((type) => (
            <Paper
              key={type.title}
              p="xl"
              radius="lg"
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #E5E7EB',
                textAlign: 'center',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)'
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.06)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = 'none'
              }}
            >
              <Box
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '12px',
                  backgroundColor: `${BRAND_COLOR}12`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                }}
              >
                <type.icon size={24} color={BRAND_COLOR} />
              </Box>
              <Text size="sm" fw={600} c="#1F2329" style={{ lineHeight: 1.5 }}>
                {type.title}
              </Text>
            </Paper>
          ))}
        </SimpleGrid>

        <Box
          mt="xl"
          p="md"
          style={{
            borderRadius: 12,
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
          }}
        >
          <Text size="sm" c="#6B7280" style={{ textAlign: 'center' }}>
            {QUERY_TYPES_CONTENT.note}
          </Text>
        </Box>
      </Container>
    </Box>
  )
}
